import styled, { css } from 'styled-components/macro';
import { TextProps } from './text.types';
import { getDSColor } from 'utils/theme';

const VariantTypes: Record<
  NonNullable<TextProps['variant']>,
  ReturnType<typeof css>
> = {
  'heading-1': css`
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
  `,
  'heading-2': css`
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  `,
  'heading-3': css`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  `,
  'heading-4': css`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  `,
  'heading-5': css`
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
  `,
  'body-16': css`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  `,
  'body-14': css`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  `,
  'caption-13': css`
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
  `,
  'numbers-13': css`
    font-family: 'Roboto Mono';
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
  `,
  'caption-11': css`
    font-size: 11px;
    font-weight: 400;
    line-height: 12px;
  `,
  'button-16': css`
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
  `,
  'button-14': css`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
  `,
  'button-12': css`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  `,
};

export const StyledText = styled.p.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'variant',
      'color',
      'align',
      'truncate',
      'lineClamp',
      'whiteSpace',
    ].includes(prop),
})<TextProps>`
  display: inline-block;
  width: fit-content;
  color: ${({ theme, color }) =>
    color ? getDSColor(theme, color) : 'inherit'};
  text-align: ${({ align }) => align ?? 'inherit'};
  white-space: ${(props) => props.whiteSpace ?? 'normal'};

  ${({ variant }) => VariantTypes[variant ?? 'body-14']};

  ${({ truncate }) =>
    truncate &&
    css`
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `};

  ${({ lineClamp }) =>
    lineClamp &&
    css`
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${lineClamp};
    `}
`;
